interface LayersProps {}

const Layers: React.FC<React.PropsWithChildren<LayersProps>> = ({ children }) => {
  return <div>{children}</div>;
};

export default Layers;
